import {ClientContext} from "common/types/client_context";
import {ClientContextsFetchAction} from "../actions/client_contexts_fetch";
import {ClientContextCreateAction} from "../actions/client_context_create";
import {MaybeUninitialised} from "modules/redux_types";
import UNINITIALISED from "utils/uninitialised";
import actionTypes from "../constants/action_types";

export default function clientContextsReducer(
  state: MaybeUninitialised<ClientContext[]> = UNINITIALISED,
  action: ClientContextsFetchAction | ClientContextCreateAction,
) {
  if (action.type === actionTypes.CLIENT_CONTEXTS_FETCH.SUCCESS) {
    return (action as ClientContextsFetchAction).payload;
  }
  if (action.type === actionTypes.CLIENT_CONTEXT_CREATE.SUCCESS) {
    const created = (action as ClientContextCreateAction).payload;
    if (state === UNINITIALISED) {
      return [created];
    }
    return [...state, created];
  }
  return state;
}
